import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/earnings-per-share',
  component: () => import('../../routes/EarningsPerShareCalculator.svelte'),
  card: {
    id: 'earnings-per-share',
    title: 'Earnings Per Share (EPS)',
    description:
      'Calculate basic and diluted EPS from net income, preferred dividends, and weighted-average shares. Solve for EPS, net income, or shares outstanding. Includes EPS growth, P/E ratio, payout ratio, and earnings yield.',
    icon: 'attach_money',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/earnings-per-share',
    category: 'Savings & Investing',
  },
  seo: {
    title:
      'Earnings Per Share (EPS) Calculator – Basic & Diluted EPS, P/E Ratio, Payout Ratio',
    description:
      'Free Earnings Per Share (EPS) calculator using EPS = (Net Income − Preferred Dividends) / Weighted Avg Common Shares. Compute Basic and Diluted EPS, P/E ratio, earnings yield, payout ratio, retention ratio, and year-over-year EPS growth. Includes company presets (mid-cap tech, large-cap S&P 500, high-growth SaaS, bank, distressed retailer). FASB Statement No. 128 compliant.',
  },
};

export default meta;